import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-bank-svg-icon',
    templateUrl: 'duotone-bank-svg-icon.component.html',
    standalone: false
})

export class DuotoneBankSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
